import {
  type MentionKinds,
  resolveKind,
} from "src/base-components/Chat/PromptBox/mentionContent";
import { Pill, resolvePillVariant } from "src/design-system/Pill";

type Props = {
  label: string;
  /** All tag attributes except `label`. */
  attrs: Record<string, string>;
  /** Per-kind config providing the icon. */
  kinds?: MentionKinds;
  /** Lets the pill shrink and truncate its label inside a flex row. */
  maxWidth?: boolean;
};

/**
 * Renders a reference as a pill for the chip rows above a message. Inside
 * the editor and message text, references render as `InlineReference`.
 */
export const ReferencePill: React.FC<Props> = ({
  label,
  attrs,
  kinds,
  maxWidth,
}) => {
  const kind = resolveKind(kinds, attrs.kind);
  return (
    <Pill
      size="sm"
      data-loc={attrs.id ? `reference-${attrs.id}` : undefined}
      maxWidth={maxWidth}
      variant={resolvePillVariant(attrs.variant)}
    >
      {kind?.icon && <Pill.Icon icon={kind.icon} />}
      <Pill.Text>{label}</Pill.Text>
    </Pill>
  );
};
